import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




const __default__ = {
  name: 'BaseButton'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    variant: {}
  },
  emits: ['click'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["base-button", { 
      'variant-outline': _ctx.variant === 'outline',
      'variant-solid': _ctx.variant === 'solid'
    }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})